import {
  GetTeamsQuery,
  GetTeamsQueryVariables,
} from "@/types/gql/generated/graphql";
import { apolloClient } from "@/utils/graphql-client";
import { GET_Teams } from "./queries/teams.graphql";

/**
 * Returns teams related to the booking
 *
 * @param id bookingId
 */
export async function getTeamsByBookingId(id: number) {
  const res = await apolloClient.query<GetTeamsQuery, GetTeamsQueryVariables>({
    query: GET_Teams,
    variables: { bookingId: String(id) },
  });
  return res.data.TeamOfParticipantsList;
}
